import * as React from 'react';
import { Price } from '../../../../../Price/Price.js';
import { PriceWithAffix } from '../../../../../Price/PriceWithAffix/PriceWithAffix.js';

const PriceDetail = ({ originalPrice , discountedPrice , isCentAmount , priceSuffix ,  })=>{
    if (originalPrice && discountedPrice && originalPrice !== discountedPrice) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "price-detail"
        }, /*#__PURE__*/ React.createElement(PriceWithAffix, {
            value: discountedPrice,
            isCentAmount: isCentAmount,
            type: "new",
            "data-t": "price-discounted",
            size: "small",
            priceSuffix: priceSuffix
        }), /*#__PURE__*/ React.createElement(Price, {
            value: originalPrice,
            isCentAmount: isCentAmount,
            type: "old",
            variant: "strikethrough",
            "data-t": "price-original",
            size: "small"
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "price"
    }, /*#__PURE__*/ React.createElement(PriceWithAffix, {
        value: originalPrice,
        isCentAmount: isCentAmount,
        type: "full",
        "data-t": "price-original",
        size: "small",
        priceSuffix: priceSuffix
    }));
};

export { PriceDetail };
//# sourceMappingURL=PriceDetail.js.map
